import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AnimatedLetters from "../AnimatedLetters";
import "./index.scss";
import Loader from "react-loaders";
import Resume from "../../assets/brian_resume.pdf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faFile } from "@fortawesome/free-solid-svg-icons";

const Home = () => {
  const [letterClass, setLetterClass] = useState("text-animate");
  const nameArr = ["B", "r", "i", "a", "n", " ", "O", "h"];
  const jobArr = [
    "S",
    "o",
    "f",
    "t",
    "w",
    "a",
    "r",
    "e",
    " ",
    "E",
    "n",
    "g",
    "i",
    "n",
    "e",
    "e",
    "r",
  ];

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 4500);
  });
  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={`${letterClass} _10`}>H</span>
            <span className={`${letterClass} _11`}>i</span>
            <span className={`${letterClass} _12`}>,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'</span>
            <span className={`${letterClass} _15`}>m</span>
            <span className={`${letterClass} _16`}> </span>
            <AnimatedLetters
              letterClass={letterClass}
              arr={nameArr}
              index={17}
            />
            <br />
            <AnimatedLetters
              letterClass={letterClass}
              arr={jobArr}
              index={25}
            />
          </h1>
          <Link to="/contact" className="flat-button">
            <FontAwesomeIcon className="flat-button-icon" icon={faEnvelope} />{" "}
            CONTACT ME
          </Link>
          <a href={Resume} download>
            <div className="flat-button">
              <FontAwesomeIcon className="flat-button-icon" icon={faFile} /> SEE
              RESUME
            </div>
          </a>
        </div>
        <div className="image-zone">
          <div class="image-container">
            <div class="block">
              <div class="side -main"></div>
              <div class="side -left"></div>
            </div>
            <div class="block">
              <div class="side -main"></div>
              <div class="side -left"></div>
            </div>
            <div class="block">
              <div class="side -main"></div>
              <div class="side -left"></div>
            </div>
          </div>
        </div>
      </div>
      <Loader type="ball-pulse" />
    </>
  );
};

export default Home;
